// import welcome from "../assets/welcome.png"

import "./Home.css";
function Home(){

    return(
        <div className="homePage">
            <h2 className="welcomeMessage">
                Welcome to Pratima Jewelers
            </h2>
         

        </div>
    );
}

export default Home;